import { PeriscopePageLayout } from './PeriscopePageLayout';
import { usePeriscopeActions } from '@hooks';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
export const PageLayoutRow = ({ record, parentIndex }) => {
    const { openPeriscope } = usePeriscopeActions();
    const onClick = useCallback((item) => {
        const { displayName, sonarObjectId } = item;
        openPeriscope({
            id: sonarObjectId,
            name: displayName,
            openedFromIndex: parentIndex,
            type: SonarObjectType.SalesforcePageLayout
        });
    }, [openPeriscope, parentIndex]);
    return React.createElement(PeriscopePageLayout, { item: record, key: record.sonarObjectId, onClick: onClick });
};
